import { axiosGet, axiosPost } from "../../react_axios/Axios";
import {
  DELETE_JURY_PROFILE_ACTION_TYPE,
  INSERT_UPDATE_JURY_PROFILE_ACTION_TYPE,
  JURY_PROFILE_DETAILS_ACTION_TYPE,
  JURY_PROFILE_LIST_ACTION_TYPE,
  JURY_SEQ_CHANGE_ACTION_TYPE,
  headers,
  insertUpdatejuryProfileUrl,
  juryProfileDeleteUrl,
  juryProfileDetailUrl,
  juryProfileListUrl,
  jurySeqChangeUrl,
} from "../../utils/constants";

export const get_jury_profile_list_action =
  (Name, Email, Phone, Experience, is_active) => async (dispatch) => {
    try {
      const mapdata = {
        Name: Name,
        Email: Email,
        Phone: Phone,
        Experience: Experience,
        is_active: is_active
      };
      const params = {
        Name: mapdata.Name === "" ? null : mapdata.Name,
        Email: mapdata.Email === "" ? null : mapdata.Email,
        Phone: mapdata.Phone === "" ? null : mapdata.Phone,
        Experience: mapdata.Experience === "" ? null : mapdata.Experience,
        is_active: mapdata.is_active === 0 ? 0 : 1
      };
      const res = await axiosGet(juryProfileListUrl, params, headers);
      dispatch({
        type: JURY_PROFILE_LIST_ACTION_TYPE,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const jury_profile_detail_action = (jury_id) => async (dispatch) => {
  try {
    const params = {
      user_id:
        sessionStorage.getItem("role_id") == 2
          ? sessionStorage.getItem("user_id") != ""
            ? sessionStorage.getItem("user_id")
            : null
          : null,
      jury_id: jury_id,
    };
    const res = await axiosGet(juryProfileDetailUrl, params, headers);

    dispatch({
      type: JURY_PROFILE_DETAILS_ACTION_TYPE,
      payload: res,
    });

    return res;
  } catch (err) {
    return Promise.reject(err);
  }
};

export const jury_profile_insertUpdate_action =
  (user_id,
    jury_id,
    Name,
    designation,
    companyName,
    EmailAddress,
    Phone,
    address,
    city,
    State,
    CountryID,
    specialization,
    EducationLevel,
    BackgroundExperience,
    LanguageProficiency,
    AboutMe,
    FilePath,
    formFileType,
    formFile,
    ProfileFilePath,
    ProfileFileType,
    ProfileFileName,
    profile_filepath, is_website_show
  ) =>
    async (dispatch) => {
      try {
        const mapdata = {
          created_by_id:
            sessionStorage.getItem("user_id") != ""
              ? sessionStorage.getItem("user_id")
              : null,
          created_by_user:
            sessionStorage.getItem("user_name") != ""
              ? sessionStorage.getItem("user_name")
              : null,
          user_id: user_id != null ? user_id : null,
          jury_id: jury_id != null ? jury_id : null,
          name: Name != null ? Name : null,
          designation: designation != null ? designation : null,
          company_name: companyName != null ? companyName : null,
          email_address: EmailAddress != null ? EmailAddress : null,
          mobile_number: Phone != null ? Phone : null,
          city: city != null ? city : null,
          state: State != null ? State : null,
          country_id: CountryID != null ? CountryID : null,
          address: address != null ? address : null,
          specialization: specialization != null ? specialization : null,
          education_level: EducationLevel != null ? EducationLevel : null,
          background_experience:
            BackgroundExperience != null ? BackgroundExperience : null,
          language_proficiency:
            LanguageProficiency != null ? LanguageProficiency : null,

          about_me:
            AboutMe != null ? AboutMe : null,

          FilePath: FilePath != '' ? FilePath : '',
          formFile: formFile != '' ? formFile : '',
          formFileType: formFileType != '' ? formFileType : '',
          ProfileFilePath: ProfileFilePath,
          ProfileFileType: ProfileFileType,
          ProfileFileName: ProfileFileName,
          profile_filepath: profile_filepath,
          is_website_show: is_website_show
        };
        const res = await axiosPost(insertUpdatejuryProfileUrl, mapdata, headers);
        dispatch({
          type: INSERT_UPDATE_JURY_PROFILE_ACTION_TYPE,
          payload: res,
        });
        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      }
    };

export const jury_profile_delete_action = (jury_id) => async (dispatch) => {
  try {
    const mapdata = {
      deleted_by_id:
        sessionStorage.getItem("user_id") != ""
          ? sessionStorage.getItem("user_id")
          : null,
      deleted_by_user:
        sessionStorage.getItem("user_name") != ""
          ? sessionStorage.getItem("user_name")
          : null,
      jury_id: jury_id,
    };

    const res = await axiosGet(juryProfileDeleteUrl, mapdata, headers);
    dispatch({
      type: DELETE_JURY_PROFILE_ACTION_TYPE,
      payload: res,
    });
    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};
export const jury_changeSeq_action = (jurySequence_list) =>
  async (dispatch) => {
    try {
      const mapdata = {
        user_id:
          sessionStorage.getItem("user_id") != ""
            ? sessionStorage.getItem("user_id")
            : null,
        jurySequence_list
      };

      const res = await axiosPost(jurySeqChangeUrl, mapdata, headers);
      dispatch({
        type: JURY_SEQ_CHANGE_ACTION_TYPE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };